var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('PageRenderer',{attrs:{"content":_vm.content,"page-key":_vm.pageKey}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }